export const buildGpsDevices = (gps_device) => ({
    ...gps_device,
    device: gps_device.device || {},
    simcard: gps_device.simcard || {}
});